import './button.css'
import SpiralIcon from './icons/spiralIcon'
import { useProject } from '../project/hook'
import { useTranslator } from '../translator/hook'

export const RemixButton = () => {
  const { t } = useTranslator()
  const { copyAndOpenProject } = useProject()

  return (
    <div className="remix-small-button" onClick={copyAndOpenProject}>
      <SpiralIcon style={{ marginRight: '5px', verticalAlign: 'middle' }} />
      {t('remix')}
    </div>
  )
}
